import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { PartnerReferral } from "@modules/partners/types";
import { ReferralFormValues } from "@modules/partners/validations";

import { editReferralService } from "./service";
import { UseEditReferralMutationOptions } from "./types";
import { listReferralsQueryKey } from "../createReferral/mutation";

export function useEditReferralMutation(
  id: number | string,
  options?: UseEditReferralMutationOptions
) {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<PartnerReferral, ApiError, Partial<ReferralFormValues>>({
    mutationFn: (data) => editReferralService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listReferralsQueryKey,
        refetchType: "all",
      });
      open?.({ type: "success", message: translate("v1/partner_referral_admin.success.edit") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
    ...options,
  });
}
